import React from 'react';

import './provide-phone-modal.scss';
import { MODAL_IDS } from 'src/constants';
import { ModalWindow } from '../../modal-window/modal-window';
import { FormProvidePhone } from '../../forms/form-provide-phone/form-provide-phone';

export const ProvidePhoneModal = () => (
  <ModalWindow
    id={MODAL_IDS.PROVIDE_MOBILE_PHONE}
    coreProps={{ id: MODAL_IDS.PROVIDE_MOBILE_PHONE }}
    bodyClassName="pt-9 pt-sm-5 pt-md-3_5 pb-3_75"
    fade
  >
    <FormProvidePhone coreProps={{ isEmptyDefaultValue: true, isIncludePhoneField: false }} />
  </ModalWindow>
);
